import RelativeList from './relative-list';

export default RelativeList;
